import { formatTeamDisplayName, isTeamDisplayPending } from '../utils/formatTeamDisplayName';

/**
 * @param {{ name?: string|null, className?: string }} props
 */
export default function TeamName({ name, className = 'team-name' }) {
  const pending = isTeamDisplayPending(name);
  const display = formatTeamDisplayName(name);
  return (
    <span className={`${className}${pending ? ' team-name--tbd' : ''}`.trim()}>{display}</span>
  );
}
